import type { ActivityEvent } from "../types";

// Helper: post-author referral attribution. Returns the props
// `<PolymarketMarketCard>` (and any other surface that takes
// postId/postAuthorId) needs to thread `?via=&p=` into its
// outgoing links + clipboard copies. Only user-authored posts
// generate attribution; system feeds (whale_trade, market_move,
// pnl_*, watchlist) intentionally pass undefined so the helper
// becomes a no-op.
export function getPostAttribution(event: ActivityEvent): { postId?: string; postAuthorId?: string } {
  const isUserPost =
    event.source_table === 'post' &&
    (event.event_type === 'user_post' ||
      event.event_type === 'user_post_trade' ||
      event.event_type === 'user_post_opinion');
  if (!isUserPost) return {};
  return { postId: event.id, postAuthorId: event.source_user_id };
}
